import { Fragment, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { PieChart } from '@mui/x-charts/PieChart';
import { WorkerStatusCard } from '../assets/style'
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { useLazyGetWorkerOverViewQuery } from '../features/dashboard/DashboardSlice';
import { useTranslation } from "react-i18next";

function OverviewWorkerStatusCard(props: { data?: any }) {

    const { data } = props;
    const [getWorkerOverView, workerOverView] = useLazyGetWorkerOverViewQuery();
    const {t, i18n} = useTranslation();
    const [dataArray, setDataArray] = useState({ongoingCount: 0, completedCount: 0, exitsCount: 0});
    const [sum, setSum] = useState(0);
    const StyledText = styled('text')(({ theme }) => ({
        fill: theme.palette.text.primary,
        textAnchor: 'middle',
        dominantBaseline: 'central',
        fontSize: 20,
    }));

    useEffect(() => {
        getWorkerOverView().then((res) => {
            if(res?.status == 'fulfilled'){
                setDataArray(res?.data);
                let a: number = res?.data?.ongoingCount + res?.data?.completedCount + res?.data?.exitsCount;
                setSum(a);
            }
        })
    }, [])
    
    const generateRows = () => {
        const rows = [];
        const defaultColor = ["#27ebf2", "#2775f2", "#f2f227", "#27f2b5", "#2a27f2", "#8927f2", "#27f253", "#f28927", "#f227b2", "#f22738"];
        rows.push({ id: 1, color: Pinball(defaultColor[1]), status: t("OngoingCount"), num: dataArray?.ongoingCount, colorMark: defaultColor[1] });
        rows.push({ id: 2, color: Pinball(defaultColor[2]), status: t("CompletedCount"), num: dataArray?.completedCount, colorMark: defaultColor[2] });
        rows.push({ id: 3, color: Pinball(defaultColor[3]), status: t("ExitsCount"), num: dataArray?.exitsCount, colorMark: defaultColor[3] });
        return rows;
    };

    const Pinball = (color: any) => {
        return <span style={{ display: "inline-block", width: "10px", height: "10px", borderRadius: "50%", backgroundColor: `${color}` }}></span>
    };

    function PieCenterLabel({ children }: { children: React.ReactNode }) {
        const { width, height, left, top } = useDrawingArea();
        return (
            <Fragment>
                <StyledText x={left + width / 2} y={top + height / 2 - 10} style={{ fontSize: '14px', fontWeight: 'bold' }} fill="#fa0542">
                    <tspan fill="#909399">{t("Total Worker")}</tspan>
                </StyledText>
                <StyledText x={left + width / 2} y={top + height / 2 + 20} style={{ fontSize: "28px", fontWeight: "bold" }}>
                    {children}
                </StyledText>
            </Fragment>
        );
    }

    return (
        <>
            <WorkerStatusCard  sx={{minHeight: '300px', maxHeight: '500px', "@media (max-width: 800px)": {maxHeight: '100%'}}}>
                <Box sx={{ height: "", marginTop: "10px", marginLeft: "15px", display: "flex", flexDirection: "column", "@media (max-width: 800px)": {  marginLeft: 0}}}>
                    <Box sx={{ height: "10%" }}>
                        <Typography variant="h6" style={{ color: "#193057" }}>{t("Overview Worker Status")}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-around", height: "90%", justifyItems: "stretch", "@media (max-width: 800px)": { minWidth: "240px", display: "flex", flexDirection: "column" } }}>
                        <Box sx={{ width: "30%", "@media (max-width: 800px)": { order: 2, maxWidth: 400, marginLeft: 10 } }}>
                            <PieChart
                                series={[
                                    {
                                        data: generateRows().map((row) => ({
                                            id: row.id,
                                            label: row.status,
                                            value: row.num,
                                            color: row.colorMark
                                        })),
                                        highlightScope: { faded: 'global', highlighted: 'item' },
                                        faded: { innerRadius: 20, additionalRadius: -20, color: 'gray' },
                                        innerRadius: 70,
                                        outerRadius: 110,
                                        paddingAngle: 1,
                                        cornerRadius: 5,
                                        startAngle: 0,
                                        endAngle: 360,
                                    },
                                ]}
                                slotProps={{
                                    legend: { hidden: true },
                                  }}
                                width={320}
                                height={400}
                            >
                                <PieCenterLabel>
                                    {sum}
                                </PieCenterLabel>
                            </PieChart>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", width: "50%", justifyContent: "center", marginTop: "-110px", "@media (max-width: 800px)": { order: 1, maxWidth: 540, alignItems: "flex-end", width: "100%", justifyContent: "center", marginTop: 2 } }}>
                            <TableContainer>
                                <Table sx={{ minWidth: 320 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell>{t("Worker Status")}</TableCell>
                                            <TableCell align="right">{t("No. of Worker")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ '& .MuiTableCell-root': { borderBottom: "none" } }}>
                                        {generateRows().map((row) => (
                                            <TableRow
                                                key={row.status}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell align="right">
                                                    {row.color}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {row.status}
                                                </TableCell>
                                                <TableCell align="right">{row.num}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                </Box>

            </WorkerStatusCard>
        </>
    );
}

export default OverviewWorkerStatusCard;